import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The RegionalAmountsTradedNationalLevel's component.
 */
const RegionalAmountsTradedNationalLevel = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Comparador-Rubros-Providers.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el sector que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de moneda para los datos, puede ser peso chileno o dólar estadounidense. {'\n'} Selecciona
          el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.
        </Item>
        <Item>Cada barra corresponde a un tipo de empresa con los que ha transado el sector seleccionado.</Item>
        <Item>Monto total transado por cada tipo de empresa según el sector y año seleccionado.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default RegionalAmountsTradedNationalLevel
